import React, { useContext } from 'react';
import { Navbar, Nav, NavDropdown } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import NavbarAdmin from './NavbarAdmin';
import { backgroundNavbar } from './styles';
import brandIcon from './assets/feb-brand.png';
import UnifyButton from '../Button';
import {
  N0, N350,
} from '../Colors';
import config from '../../config';
import UserAuthContext from '../Context/userContext';

const NavBar = () => {
  const userConsumer = useContext(UserAuthContext);

  const logout = () => {
    localStorage.clear();
    userConsumer.setUserAuth({
      role: null,
    });
    window.location = `${config.API_BASE_URL}api/account/logout`;
  };

  if (userConsumer.role === 'admin' || userConsumer.role === 'superadmin') {
    return (
      <NavbarAdmin logout={logout} role={userConsumer.role} />
    );
  }
  return (
    <Navbar collapseOnSelect expand="lg" className={backgroundNavbar}>
      <Navbar.Brand href="#home">
        <img
          src={brandIcon}
          className="d-inline-block align-top"
          alt="Icon FEB UI"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="ml-auto">
          <Nav.Link href="/">Home</Nav.Link>
          <NavDropdown
            title="Pengajuan Kegiatan KUM"
            id="collasible-nav-dropdown"
          >
            <NavDropdown.Item href="/Mahasiswa/PengajuanKuliahUmum/">Ajukan Pengajuan KUM</NavDropdown.Item>
            <NavDropdown.Item href="/Mahasiswa/PengajuanKuliahUmum/DaftarProgres">Status Pengajuan KUM</NavDropdown.Item>
          </NavDropdown>
          <NavDropdown title="Klaim KUM" id="collasible-nav-dropdown">
            <NavDropdown.Item href="/Mahasiswa/BuatKlaim">Ajukan Klaim KUM</NavDropdown.Item>
            <NavDropdown.Item href="/Mahasiswa/HistoriPengajuanPartisipasi">
              Status Klaim KUM
            </NavDropdown.Item>
          </NavDropdown>
          {userConsumer.role
            ? (
              <>
                <Navbar.Text className="welcome">
                  {`Selamat Datang ${localStorage.getItem('nama')}`}
                </Navbar.Text>
                <Nav.Link>
                  <Button data-testid="logout" variant="danger" onClick={logout} style={{ backgroundColor: '#B23B3B', color: '#F5F6F8', borderColor: '#B23B3B' }}>Log Out</Button>
                </Nav.Link>
              </>
            )
            : (
              <Nav.Link href={`${config.API_BASE_URL}api/account/login`}>
                <UnifyButton color={N350} textColor={N0}>
                  Log In
                </UnifyButton>
              </Nav.Link>
            )}
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};
export default NavBar;
